<article class="block type-flex form-wizard" *ngIf="project">
  <div class="col-left">
    <header class="form-wizard-header">
      <h1 class="block-header-title" *ngIf="project.Title">TP-{{ project.TPNumber }} {{ project.Title }}</h1>
      <h1 class="form-wizard-header-title" *ngIf="!project.Title">'New project'</h1>
      <div class="form-wizard-header-text">
        <p [innerHTML]="project.Summary"></p>
      </div>
    </header>

    <ol class="form-wizard-chapters-list">
      <li class="form-wizard-chapter-list-item" *ngIf="project.Id">
        <a class="form-wizard-chapter-link no--number" [routerLink]="['/project', project.Id]" (click)="setTab(0)">General info & photos</a>
      </li>
      <li class="form-wizard-chapter-list-item" *ngIf="project.Id">
        <a class="form-wizard-chapter-link no--number" [routerLink]="['/project', project.Id]" (click)="setTab(1)">Teams</a>
      </li>
      <li class="form-wizard-chapter-list-item" *ngIf="project.Id">
        <a class="form-wizard-chapter-link no--number" [routerLink]="['/project', project.Id]" (click)="setTab(2)">Sustainability</a>
      </li>
      <li class="form-wizard-chapter-list-item is--current">
        <a class="form-wizard-chapter-link no--number">Socialmedia</a>
      </li>
    </ol>
  </div>

  <div class="col-right">
    <app-social-item-list
      [posts]="socialItems"
      [previewObj]="preview"
      (onPreview)="handlePreview($event)"
      (onAdd)="handleAdd($event)"
      (onDelete)="handleDelete($event)"
    ></app-social-item-list>
    <!-- <button (click)="instaAuth()" *ngIf="!instaToken">Insta Auth</button> -->
    <!-- <input type="text" #instaQ>
<button (click)="searchInsta(instaQ.value)">Search insta</button>
  <pre>{{instaResults | json}}</pre> -->
  </div>
</article>
